import { useState, useEffect } from 'react'
import { toastError, toastSuccess } from '../../util/toastUtil'
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom'
import { useCustomAxios } from '../../axiosInstance'
import 'react-responsive-carousel/lib/styles/carousel.min.css' // requires a loader
import '../Login/login.css'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormControl from '@mui/material/FormControl'
import FormLabel from '@mui/material/FormLabel'
import NoteSection from './NoteSection'
import { ResetPasswordContext } from './index'
import { useContext } from 'react'
import MuiButton from '../../components/MaterialComponent/MuiButton'
import MaskedInput from '../../components/MaskedInput/MaskedInput'

const ResetPassword = ({ setCurrentStep, STEP, handleOtp, setLoadingData }) => {
    const axios = useCustomAxios()
    const navigate = useNavigate()

    const [selectedRadio, setSelectedRadio] = useState(null)
    const [number, setNumber] = useState('')
    const [contextData, setContextData] = useContext(ResetPasswordContext)

    // console.log(contextData)

    function removeFormatting(phoneNumber) {
        // Remove all non-numeric characters
        return phoneNumber.replace(/\D/g, '')
    }
    const handleSubmitResetPassword = (e) => {
        e.preventDefault()
        const cellnumber = number.replace(/\D/g, '')

        if (selectedRadio === null) {
            toastError('Please select a method of sending a one time passcode')
            return
        }
        if (selectedRadio === 'phone_number' && cellnumber.length === 0) {
            toastError('A mobile number is required')
            return
        }
        if (selectedRadio === 'phone_number' && cellnumber.length < 10) {
            toastError('Please enter a valid mobile number')
            return
        }

        const data = {
            ...contextData,
            selectedOption: selectedRadio,
            phoneNumber: removeFormatting(number.toString()),
        }
        // console.log(data)
        setContextData(data)
        handleOtp(data)
    }

    return (
        <>
            <form
                className="form"
                style={{ maxWidth: '600px', minWidth: '550px' }}
                onSubmit={handleSubmitResetPassword}>
                <h5>Reset Forgotten Password</h5>
                {/* <h6 style={{ fontWeight: 'bold' }}>Select the method of sending a one time passcode </h6> */}
                <FormControl>
                    {contextData.userDetails.phoneNumber !== '0' && (
                        <FormLabel id="demo-radio-buttons-group-label">
                            Select the method of sending a one time passcode{' '}
                        </FormLabel>
                    )}

                    {
                        <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            defaultValue="phone_number"
                            name="radio-buttons-group"
                            value={selectedRadio}
                            onChange={(e) => {
                                setSelectedRadio(e.target.value)
                            }}>
                            {contextData.userDetails.phoneNumber !== '0' ? (
                                <>
                                    {' '}
                                    <FormControlLabel
                                        value="phone_number"
                                        control={<Radio />}
                                        label="Text Message"
                                    />
                                    {selectedRadio === 'phone_number' && (
                                        <b
                                            style={{
                                                fontSize: '12px',
                                                marginBottom: '5px',
                                            }}>{`Message will be Sent to +1 ${contextData.userDetails.phoneNumber}`}</b>
                                    )}
                                    {selectedRadio === 'phone_number' && (
                                        <MaskedInput
                                            type="text"
                                            id="phoneNumber"
                                            name="phoneNumber"
                                            mask="(999) 999-9999"
                                            placeholder="(XXX) XXX-XXXX"
                                            onChange={(e) =>
                                                setNumber(e.target.value)
                                            }
                                        />
                                    )}
                                </>
                            ) : null}

                            <FormControlLabel
                                value="email"
                                control={<Radio />}
                                label="Email"
                            />
                        </RadioGroup>
                    }
                </FormControl>
                {selectedRadio === 'email' && (
                    <p style={{ fontWeight: 'bold' }}>
                        Email will be sent to{' '}
                        <span style={{ color: 'blue' }}>
                            {contextData.userDetails.email}
                        </span>
                    </p>
                )}
                {selectedRadio === 'phone_number' && <NoteSection />}

                <MuiButton>Continue</MuiButton>
            </form>
        </>
    )
}
export default ResetPassword
